<template>
  <Toast position="top-right" group="main">
    <template #message="slotProps">
      <div class="p-toast-message-content" style="display: flex; align-items: flex-start; gap: 0.5rem;">
        <i :class="['p-toast-message-icon', toastIcon(slotProps.message.severity)]" style="font-size: 1.2rem; margin-top: 2px;"></i>
        <div style="flex: 1;">
          <span class="p-toast-summary" style="font-weight: 600; display: block;">{{ slotProps.message.summary }}</span>
          <div class="p-toast-detail" style="margin-top: 0.25rem;">{{ slotProps.message.detail }}</div>
          <button
            v-if="slotProps.message.action"
            class="p-button p-button-sm p-button-warning"
            style="margin-top: 0.5rem; font-size: 0.85rem; padding: 0.3rem 0.75rem; cursor: pointer;"
            @click="handleToastAction(slotProps.message.action)"
          >
            {{ slotProps.message.action.label }}
          </button>
        </div>
      </div>
    </template>
  </Toast>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Toast from 'primevue/toast';

export default {
  name: 'ToastManager',
  components: { Toast },

  computed: {
    ...mapState('toastNotifications', ['queue']),
  },

  mounted() {
    if (this.queue.length > 0) {
      this.processQueue();
    }
  },

  watch: {
    queue: {
      handler(newQueue) {
        if (newQueue.length > 0) {
          this.processQueue();
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('toastNotifications', ['pop']),

    processQueue() {
      if (!this.queue.length) return;
      const notification = this.queue[0];
      this.$toast.add({
        group: 'main',
        severity: notification.severity || 'info',
        summary: notification.summary || 'Notification',
        detail: notification.detail || '',
        life: notification.life || 3000,
        action: notification.action || null,
      });

      this.$nextTick(() => {
        this.pop();
        if (this.queue.length > 0) {
          this.processQueue();
        }
      });
    },

    handleToastAction(action) {
      if (action && action.name) {
        this.$store.dispatch(action.name);
      }
    },

    toastIcon(severity) {
      const icons = {
        info: 'pi pi-info-circle',
        success: 'pi pi-check',
        warn: 'pi pi-exclamation-triangle',
        error: 'pi pi-times-circle',
      };
      return icons[severity] || 'pi pi-info-circle';
    },
  }
};
</script>
